import { matchPath } from 'react-router-dom';

export const isRoutePart = (pathname: string, href?: string) =>
  !!href &&
  !!matchPath(pathname, {
    path: href,
    exact: false,
  });
